import React, { FC, Ref, useRef, useState } from 'react';
import './LastTripItem.scss';
import Image from '../../../../../../components/ui/components/Image/Image';
import PriceViewer from '../../../../../../components/ui/components/PriceViewer/PriceViewer';
import IconDots from '../../../../../../components/ui/icons/icons/IconDots';
import OutsideClick from '../../../../../../components/common/OutsideClick/OutsideClick';
import { Link, useHistory } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../../../../hooks/reduxHooks';
import { hideAccountOrdersThunk } from '../../../../../../store/account/orders/orders-thunks';
import ModalConfirm from '../../../../../../components/ui/modals/ModalConfirm/ModalConfirm';
import AppButton from "../../../../../../components/ui/components/Buttons/AppButton/AppButton";
import { addToOrderThunk, confirmOrderThunk, goToPaymentThunk } from "../../../../../../store/order/order-thunk";
import { useDispatch } from "react-redux";
import accountOrdersDetailApi from "../../../../../../api/account-orders-detail-api";
import { OrderPaymentRedirectType, OrderPaymentResponse } from "../../../../../../types/order";
import { RouteNames } from "../../../../../../routes";
import OrderConfirmOfferModal from "../../../../../Order/OrderIndex/OrderConfirmOfferModal/OrderConfirmOfferModal";
import ErrorModal from "../../../../../../components/ui/modals/ErrorModal";
import { translate } from "../../../../../../helpers/translatioHelpers";
import { setOrderIsLoading } from "../../../../../../store/order/order-reducer";
import appToastr from "../../../../../../services/appToastr";
import { collectAllErrorToString } from "../../../../../../helpers/network";
import usePaymentOnline from "../../../../../../hooks/usePaymentOnline";

interface Props {
  date: string;
  place: string;
  totalPrice: number;
  id: number;
  image: string;
  route: string;
  canPayOnline: boolean;
}

const NavButton = ({ onClick }) => {
  return (
    <button onClick={onClick}>
      <IconDots/>
    </button>
  );
};

const ContextMenu = ({ onClose, handleBook, leaveComment, onRemove }) => {
  return (
    <div className="order-item-menu">
      <OutsideClick onOutsideClick={onClose}>
        <ul>
          <li onClick={handleBook}>Забронювати знову</li>
          <li onClick={leaveComment}>Оцінити та залишити відгук</li>
          <li onClick={onRemove}>Видалити бронювання</li>
        </ul>
      </OutsideClick>
    </div>
  );
};

const LastTripItem: FC<Props> = props => {
  const { image, date, place, totalPrice, route, id, canPayOnline } = props;
  const { showIndicator, AdditionalComponents, makePayment } = usePaymentOnline();


  const handlePay = (e) => {
    e.stopPropagation();
    e.preventDefault();

    makePayment(id)
  }


  return (
    <div className="last-trip-item">
      <AdditionalComponents />
      <Link to={route}>
        <div className="last-trip-item__wrapper">
          <Image src={image} aspectRatio={'1:1'} className="last-trip-item__image"/>
          <div className="last-trip-item__block-information">
            <div className="last-trip-item__block-date">
              <div className="last-trip-item__date">{date}</div>
              <div className="last-trip-item__setting">{/*<IconMore/>*/}</div>
            </div>
            <div className="last-trip-item__name">{place}</div>
            <div className="last-trip-item__price">
              <PriceViewer price={totalPrice}/>
              {canPayOnline &&
                <AppButton showIndicator={showIndicator} theme="outline" size="small" onClickCapture={handlePay}>Оплатити</AppButton>}
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default LastTripItem;
